@if (isQuarterCloseEnabled() && isClosingPanelEnabled()) {
  <aux-workflow-panel
    className="mb-7"
    [workflowName]="workflowName"
    [processing]="iCloseMonthsProcessing()"
    [hasUserPermissions]="userHasLockInvestigatorDataPermission()"
  />
}

@if (showTotalCardsSection$ | async) {
  <div class="my-5 flex items-center justify-between">
    <div class="flex space-x-4">
      <aux-card
        topText="Total # of Sites"
        [middleText]="(gridData$ | async)?.length || zeroHyphen"
        className="min-w-[230px]"
      />

      <aux-card
        topText="Total # of Activated Sites"
        [middleText]="this.activatedSitesTotal || zeroHyphen"
        className="min-w-[230px]"
      />

      <aux-card
        topText="Total # of Current Active Sites"
        [middleText]="this.currentlyActiveSitesTotal || zeroHyphen"
        className="min-w-[230px]"
      />

      <aux-card
        topText="Total # of Closed Sites"
        [middleText]="this.closedSitesTotal || zeroHyphen"
        className="min-w-[230px]"
      />
    </div>
  </div>
}

@if (sitesQuery.selectLoading() | async) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((sitesQuery.selectLoading() | async) === false && (loadingTable | async) === false) {
  <div class="my-4">
    <section class="flex flex-wrap items-end justify-between gap-2">
      <form class="flex flex-wrap gap-2" [formGroup]="transactionsForm">
        <aux-input
          class="mt-4 w-52"
          placeholder="Search"
          formControlName="name_filter"
          label=" "
          icon="Search"
          iconPosition="left"
          hotKey="/"
        />
        <aux-multi-select-dropdown
          placeholder="Select"
          label="Country:"
          formControlName="country"
          class="w-48"
          bindLabel="name"
          bindValue="name"
          [items]="(countryOptions$ | async)!"
          [loading]="(dataLoading$ | async)!"
          [searchable]="true"
        />
        <aux-multi-select-dropdown
          placeholder="Select"
          label="Currency:"
          formControlName="currency"
          class="w-36"
          bindLabel="name"
          bindValue="name"
          [items]="(currencyOptions$ | async)!"
          [loading]="(dataLoading$ | async)!"
          [searchable]="true"
        />
        <div>
          <span class="mb-1 block text-xs">Vendor Contract:</span>
          <ng-select
            class="big-dropdown tabular-nums sm:w-[150px] md:w-[200px] lg:w-[250px] 2xl:w-[350px]"
            placeholder="Select"
            formControlName="managed_by_name"
            bindLabel="name"
            bindValue="name"
            [multiple]="true"
            [clearable]="true"
            [loading]="(dataLoading$ | async)!"
            [items]="(organizationQuery.allVendors$ | async)!"
          >
            <ng-template let-item="item" ng-option-tmp>
              <div
                class="block truncate text-sm"
                #text
                [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.name : ''"
                [auxTooltipPositions]="optionTooltipPositions"
              >
                {{ item.name }}
              </div>
            </ng-template>
            <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp>
              @if (items.length === 1) {
                <div class="ng-value">
                  @for (item of castItemsToVendorOptions(items) | slice: 0 : 1; track item) {
                    <div class="flex">
                      <span class="ng-value-icon left" aria-hidden="true" (click)="clear(item)">
                        ×
                      </span>
                      <span
                        class="ng-value-label max-w-[200px] overflow-hidden text-ellipsis"
                        #text
                        [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.name : ''"
                        [auxTooltipPositions]="optionTooltipPositions"
                      >
                        {{ item.name }}
                      </span>
                    </div>
                  }
                </div>
              }
              @if (items.length > 1) {
                <div class="ng-value">
                  <span class="ng-value-label">{{ items.length }} Selected</span>
                </div>
              }
            </ng-template>
          </ng-select>
        </div>
        <span
          class="btn--hyperlink mr-3 mt-6 cursor-pointer whitespace-nowrap"
          (click)="resetFilter()"
        >
          Reset Filters
        </span>
      </form>
      <div class="flex items-center space-x-2">
        <aux-button-group
          variant="secondary"
          label="Add"
          [options]="editOptions()"
          [disabled]="!!siteCtx.disabledAddSiteUI()"
          [auxTooltip]="
            siteCtx.addSiteActionTooltips().length === 1 ? siteCtx.addSiteActionTooltips()[0] : ''
          "
          [template]="siteCtx.addSiteActionTooltips().length > 1 ? addSiteErrors : undefined"
          [position]="addButtonGroupOverlayPosition"
        />
        <ng-template #addSiteErrors>
          <aux-errors-tooltip [errors]="siteCtx.addSiteActionTooltips()" />
        </ng-template>
      </div>
    </section>

    <aux-checkbox
      class="mb-4"
      [id]="'show-rows-with-site-flags'"
      [checked]="showRowsWithSiteFlags()"
      (customChange)="showRowsWithSiteFlags.set($event)"
    >
      Show Only Flagged Sites
    </aux-checkbox>

    <ag-grid-angular
      class="ag-theme-alpine sites-table h-full w-full tabular-nums"
      [gridOptions]="(gridOptions$ | async)!"
      [rowData]="(gridData$ | async)!"
      [domLayout]="'autoHeight'"
      [quickFilterText]="transactionsForm.getRawValue()?.name_filter"
      (gridReady)="onGridReady($event)"
      auxStickyGrid
    />
  </div>
}
